@if (stateIcon(); as _icon) {
  <fa-icon
    [icon]="_icon"
    [fixedWidth]="true"
    class="fmnts-pseudo-checkbox__icon"
  />
}
